import {
  ContentAttachment,
  ContentAttachmentCreateInput,
  ContentAttachmentListResult
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listContentAttachments(contentId: number): Promise<ContentAttachmentListResult> {
  return httpClient.get<ContentAttachmentListResult>(`/protected/content/${contentId}/attachments`);
}

export async function addContentAttachment(
  contentId: number,
  payload: ContentAttachmentCreateInput
): Promise<ContentAttachment> {
  return httpClient.post<ContentAttachment>(`/protected/content/${contentId}/attachments`, payload);
}

export async function removeContentAttachment(contentId: number, childContentId: number): Promise<void> {
  return httpClient.delete<void>(`/protected/content/${contentId}/attachments/${childContentId}`);
}
